<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div style="" ref="sku_detail_page">
        <Wp_nav_bar title="商品详情" :hasClick="true" @click="closeDetail"></Wp_nav_bar>
        <div v-if="skuInfo">
            <Wp_img_swipe v-if="img_list && img_list.length > 0"
                          :list="img_list"
                          :height="screenWidth + 'px'"
                          @changeImg="getImageIndex"
            ></Wp_img_swipe>

            <div class="sku_title" style="padding: 12px 10px 0px 10px; font-size: 14px">
                <h3>
                    <span>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-if="skuInfo.merchant_type === 3">拼多多旗舰店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else-if="skuInfo.merchant_type === 4">拼多多专卖店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else-if="skuInfo.merchant_type === 5">拼多多专营店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else>拼多多</van-tag>
                    </span>
                    <span v-clipboard:copy="skuInfo.goods_name"
                          v-clipboard:success="copySuccess"
                          v-clipboard:error="copyError"
                    >{{skuInfo.goods_name}}</span>
                </h3>
            </div>

            <div style="text-align: right; padding: 10px 10px 0px 10px; color: #666666">
                <span v-if="couponData && couponData.discount > 0" style="margin-right: 15px">
                    原价<span style="text-decoration:line-through"> ¥ {{skuInfo.min_group_price / 100}}</span>
                </span>
<!--                <span style="margin-right: 15px">-->
<!--                    评论数 {{skuInfo.comments}}-->
<!--                </span>-->
<!--                <span style="margin-right: 15px">-->
<!--                    好评率 {{skuInfo.goodCommentsShare}}%-->
<!--                </span>-->
                <span style="" @click="clickToBuy">
                    查看详情>
                </span>
            </div>

            <div class="sku_tags" style="display: inline-block; margin-top: 5px; padding-left: 10px">

                <div style="float:left;margin: 2px" v-if="couponData && couponData.discount">
                    <JdCouponBar :couponData="couponData" size="medium" ></JdCouponBar>
<!--                    <van-tag mark type="danger" size="medium" style="padding: 2px 12px">券:¥ {{couponData.discount}}</van-tag>-->
                </div>

<!--                <span v-if="skuInfo.pinGouInfo.pingouPrice" style="float:left;color:red;margin: 2px 5px">-->
<!--                                <Icon type="ios-contacts" size="20"/>-->
<!--                                {{skuInfo.pinGouInfo.pingouTmCount}}人拼-->
<!--                    </span>-->

<!--                <div style="float:left;margin: 2px" v-if="skuInfo.isHot===1">-->
<!--                    <van-tag color="red" plain size="medium">爆品</van-tag>-->
<!--                </div>-->

<!--                <div v-if="robotList && robotList.length > 0" style="position: absolute; margin-top: 2px; right: 12px">-->
<!--                    <Wp_join_robot_status_tag_model :is-pushed="is_pushed"></Wp_join_robot_status_tag_model>-->
<!--                </div>-->
            </div>

            <div style="color:red; padding: 2px 15px;">
                <span v-if="couponData && couponData.discount">
                    <span style="font-size: 13px">
                        券后价 ¥ <span style="font-size: 20px">{{(Number(skuInfo.min_group_price / 100) - Number(couponData.discount)).toFixed(2)}}</span>
                    </span>
                </span>
                    <span v-else style="font-size: 13px">
                    内购价 ¥ <span style="font-size: 20px">{{skuInfo.min_group_price / 100}}</span>
                </span>

                <span v-if="(!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super') && !$common.isClient_whole()"
                      style="float: right; padding-top: 3px">
                    预估佣金 ¥ <span style="font-size: 15px">{{commission}}</span>
                </span>
            </div>
            <div style="text-align: right; padding-right: 10px; color: #999999; font-size: 13px"
                 v-clipboard:copy="skuInfo.goods_sign.toString()"
                 v-clipboard:success="copySuccess"
                 v-clipboard:error="copyError"
            >
                商品编号: {{skuInfo.goods_sign}}
            </div>
            <van-divider style="padding: 0px; margin: 0px"></van-divider>

<!--            <div v-if="is_coupon_can_use && robotList && robotList.length > 0 && (!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super') && !$common.isClient_whole()"-->
<!--                 style="padding: 10px" >-->
<!--                <van-row style="text-align: center; padding: 5px 0px">-->
<!--                    <van-col span="8">-->
<!--                        <Wp_join_robot_button_model :sku-info="skuInfo"-->
<!--                                                    :link-content="linkContent"-->
<!--                                                    :robot-list="robotList"-->
<!--                                                    :img-list="img_list"-->
<!--                                                    width="90%"-->
<!--                                                    :coupon-data="couponData"-->
<!--                                                    @getPushStatus="getPushStatus"-->
<!--                                                    @getAllRobatSkuData="getAllRobatSkuData"-->
<!--                                                    @updataBadegSync="updataBadegSync"-->

<!--                        ></Wp_join_robot_button_model>-->
<!--                    </van-col>-->
<!--                    <van-col span="8">-->
<!--                        <van-button size="small" type="danger"-->
<!--                                    style="width: 90%; background-color: orange; border: 1px solid orange; color: white"-->
<!--                                    v-clipboard:copy="linkContent.replace('<br/>','\n')"-->
<!--                                    v-clipboard:success="onCopySuccess"-->
<!--                                    v-clipboard:error="onError">-->
<!--                            复制文案-->
<!--                        </van-button>-->
<!--                    </van-col>-->
<!--                    <van-col span="8">-->
<!--                        <van-button size="small" type="info" style="width: 90%" @click="shareImg">分享图片</van-button>-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <span style="font-size: 15px">商品文案：</span>-->
<!--                <van-field-->
<!--                        v-model="linkContent"-->
<!--                        type="textarea"-->
<!--                        readonly-->
<!--                        :autosize="{maxHeight: 300, minHeight: 100}"-->
<!--                        style="border: 1px solid #77FFCC55; border-radius: 4px; padding: 10px; background-color: #77FFCC22"-->
<!--                ></van-field>-->

<!--            </div>-->

<!--            <div v-if="tb_command_content" style="text-align: center; padding: 10px">-->
<!--                <van-row style="margin-bottom: 10px">-->
<!--                    <van-col span="12">-->
<!--                        <van-button size="small" type="warning" style="width: 90%" @click="shareImg">分享图片</van-button>-->
<!--                    </van-col>-->
<!--                    <van-col span="12">-->
<!--                        <van-button size="small" type="info"-->
<!--                                    style="width: 90%;"-->
<!--                                    v-clipboard:copy="tb_command_content.replace('<br/>','\n')"-->
<!--                                    v-clipboard:success="onCopySuccess"-->
<!--                                    v-clipboard:error="onError">-->
<!--                            复制口令-->
<!--                        </van-button>-->
<!--                    </van-col>-->
<!--                </van-row>-->

<!--                <van-field id="tb_command_field"-->
<!--                        v-model="tb_command_content"-->
<!--                        type="textarea"-->
<!--                        readonly-->
<!--                        :autosize="{maxHeight: 300, minHeight: 100}"-->
<!--                        style="border: 1px solid #77FFCC55; border-radius: 4px; padding: 10px; background-color: #77FFCC22"-->
<!--                ></van-field>-->
<!--            </div>-->

            <van-divider style="padding: 0px; margin: 0px"></van-divider>

            <van-row style="text-align: center">
                <van-col span="8" >
                    <div style="text-align: center;">
                        <van-button icon="passed" size="mini"
                                    style="font-size: 11px; color: #666666; background-color: rgba(0,0,0,0); border: 0px"
                        >精选商品</van-button>
                    </div>
                </van-col>
                <van-col span="8">
                    <div style="text-align: center;">
                        <van-button icon="passed" size="mini"
                                    style="font-size: 11px; color: #666666; background-color: rgba(0,0,0,0); border: 0px"
                        >品质保证</van-button>
                    </div>
                </van-col>
                <van-col span="8">
                    <div style="text-align: center;">
                        <van-button icon="passed" size="mini"
                                    style="font-size: 11px; color: #666666; background-color: rgba(0,0,0,0); border: 0px"
                        >无忧售后</van-button>
                    </div>
                </van-col>
            </van-row>

<!--                <div class="bottom_button" :container="container" :style="{bottom: bottom_px}">-->
            <div>
                <div style="height: 70px"></div>
                <div class="bottom_button" :style="{bottom: bottom_px}">

                    <van-row>
                        <van-col span="4">
                            <div @click="clickToHome">
                                <div style="text-align: center;  margin-top: 5px">
                                    <van-button icon="home-o" size="mini" style="font-size: 16px; color: #777777; background-color: rgba(0,0,0,0); border: 0px"></van-button>
                                </div>
                                <div style="text-align: center; color: #777777;">首页</div>
                            </div>
                        </van-col>
<!--                        <van-col span="10">-->
<!--                            <van-button size="large"-->
<!--                                        style="background-color: orange; border: 1px solid orange; border-radius: 0px; color: white"-->
<!--                                        @click="clickToShare"-->
<!--                            >分享海报-->
<!--                            </van-button>-->
<!--                        </van-col>-->
<!--                        <van-col span="10">-->
<!--                            <van-button size="large"-->
<!--                                        type="danger"-->
<!--                                        style="border-radius: 0px"-->
<!--                                        @click="clickToBuy"-->
<!--                            >立即购买</van-button>-->
<!--                        </van-col>-->
                        <van-col span="20">
                            <van-button size="large"
                                        type="danger"
                                        style="border-radius: 0px"
                                        @click="clickToBuy"
                            >立即购买</van-button>
                        </van-col>
                    </van-row>

                </div>
            </div>

<!--            <Wp_jd_skuinfo_poster ref="Wp_jd_skuinfo_poster"-->
<!--                                  :sku-info="skuInfo"-->
<!--                                  :coupon-data="couponData"-->
<!--                                  :poster-img="posterImg"-->
<!--            ></Wp_jd_skuinfo_poster>-->
        </div>
    </div>
</template>

<script>
    // import Vue from 'vue';

    import Wp_nav_bar from "../../custom/Wp_nav_bar";
    import Wp_img_swipe from "../../custom/Wp_img_swipe";
    import Wp_jd_skuinfo_poster from "../../custom/Wp_jd_skuinfo_poster";

    import {ImagePreview, Toast } from 'vant';
    import JdCouponBar from "../../custom/JdCouponBar";
    import Wp_join_robot_button_model from "../../custom/Wp_join_robot_button_model";
    import Wp_join_robot_status_tag_model from "../../custom/Wp_join_robot_status_tag_model";
    // Vue.use(Toast);
    // Vue.use(ImagePreview);

    export default {
        name: "Wp_pdd_sku_detail_page",
        components: {
            Wp_join_robot_status_tag_model,
            Wp_join_robot_button_model, JdCouponBar, Wp_jd_skuinfo_poster, Wp_img_swipe, Wp_nav_bar},

        props:{
            type:{type: String, default: "page"}, //popup,page
            datas:{type: Object, default: null},
            skuIdString:{type: String, default: ''},
        },
        data(){
            return{
                skuInfo: null,
                img_list:[],//[{"img": "img_url", ...},{}]

                // 屏幕宽
                screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,

                couponData: {},

                select_img_index: 0,
                posterImg: "",

                bottom_px: "0px",

                newLink: "",
                linkContent: "",

                //佣金金额
                commission: 0,
                //佣金比例
                commissionShare: 0,
                // //助理（机器人）列表
                robotList:[],

                // test_channel_name: "V006",
                channel_name: this.$store.state.username,
                //
                // //点击加入助理时弹出的内容展示
                // show_dialog_for_robot: false,
                // currentIndex: 0,
                // //是否可以加入助理
                // join_robot_status: true,

                //是否已推送
                is_pushed: false,

                is_coupon_can_use: true,

                tb_command_content: '',
                tb_commmand: ''
            }
        },

        watch:{
            datas:{
                handler(){
                    this.initSkuInfo();
                },
                deep: true
            },
            skuIdString(){
                this.$log("-------------skuIdString------------")
                this.initSkuInfo();
            },
        },

        created(){
            this.initSkuInfo();
            this.getRobotList();
            //展示详情，用于禁用列表的下拉刷新
            // this.$common_pdd.is_show_pdd_sku_detail = true;
        },

        mounted(){
            this.container = this.$refs.container;
        },

        methods:{

            initSkuInfo(){
                //两种方式展示详情，datas为通过props传递过来的数据，用户popup类型，$common.static_skuInfo为通过router打开新页面

                let skuId = this.$common.getUrlKey("skuId");

                if(skuId){
                    this.bottom_px = "50px";
                    let params = {
                        goodsidlist: this.skuInfo.goods_sign
                    };

                    this.$getSelectGoods_pdd(params, response=>{
                        if(response && response.code === 200){
                            if(response.data && response.data.goods_search_response && response.data.goods_search_response.goods_list){
                                this.skuInfo = response.data.goods_search_response.goods_list[0];

                                if(this.skuInfo){
                                    this.img_list.push({
                                        img: this.skuInfo.goods_image_url
                                    });

                                    this.findCoupon();
                                    this.initCommission();
                                    // this.makeLinks();
                                }
                            }
                        }
                    })
                }else{
                    if(this.datas){
                        this.skuInfo = this.datas;
                    }else if(this.$common.static_skuInfo){
                        this.skuInfo = this.$common.static_skuInfo;
                    }

                    if(this.skuInfo){
                        if(this.skuInfo.goods_image_url){
                            this.img_list.push({
                                img: this.skuInfo.goods_image_url
                            });
                        }

                        this.findCoupon();
                        this.initCommission();
                        // this.makeLinks();
                    }
                }

            },


            copySkuName(){
                if(this.skuInfo){
                    this.copyToClipboard(this.skuInfo.skuName);
                }else{
                    Toast({
                        message: "商品信息异常，复制失败",
                    });
                }
            },

            copySkuId(){
                if(this.skuInfo){
                    this.copyToClipboard(this.skuInfo.skuId + "");
                }else{
                    Toast.fail({
                        message: "商品信息异常，复制失败",
                    });
                }
            },

            copyToClipboard(text){
                if(text){
                    window.navigator.clipboard.writeText(text)
                        .then(() => {
                            window.navigator.clipboard.readText().then(clipText=>{
                                if(clipText === text){
                                    this.copySuccess();
                                }else{
                                    this.copyError();
                                }
                            });
                        })
                        // eslint-disable-next-line no-unused-vars
                        .catch(err => {
                            this.copyError();
                        });

                }
            },

            copySuccess(){
                Toast.success({
                    message: "复制成功",
                });
            },
            copyError(){
                Toast.fail({
                    message: "复制失败",
                });
            },

            getImageIndex(index){
                this.select_img_index = index;
                if(this.skuInfo){
                    if(this.skuInfo.goods_image_url){
                        this.posterImg = this.skuInfo.goods_image_url;
                    }
                }
            },

            clickToHome(){
                this.closeDetail();
            },

            closeDetail(){
                this.clearDatas();
                if(this.type === "popup"){
                    this.$log('---------------close----------------')
                    this.$emit("clickToCloseDetail");
                }else if(this.type === "page"){
                    this.$router.back();
                }
                //关闭详情，启用用列表的下拉刷新
                // this.$common_pdd.is_show_pdd_sku_detail = false;
            },

            clearDatas(){
                this.skuInfo = null;
                this.img_list = [];
                this.couponData = {};
                this.newLink = "";
            },

            clickToShare(){
                if(this.$common.getPid()) {
                    this.$refs.Wp_jd_skuinfo_poster.showSharePop();
                }else{
                    // this.$dialog.alert({
                    //     message: "缺少渠道id，操作中断"
                    // })
                    Toast.fail({
                        message: "缺少渠道id\n操作中断"
                    })
                }
            },

            clickToBuy(){
                if(this.$common.getPid()){
                    if(this.newLink){

                        if(this.$common.isClient_hm()){
                            //如果是河马，则跳转小程序页面
                            this.navigateToJd(this.newLink);
                        }else{
                            location.href = this.newLink;
                        }
                    }else{
                        this.makeLinks(shortURL =>{
                            this.newLink = shortURL;
                            if(this.$common.isClient_hm()){
                                //如果是河马，则跳转小程序页面
                                this.navigateToJd(this.newLink);
                            }else{
                                location.href = this.newLink;
                            }
                        });
                    }

                }else{
                    // this.$dialog.alert({
                    //     message: "缺少渠道id，操作中断"
                    // })
                    Toast.fail({
                        message: "缺少渠道id\n操作中断"
                    })
                }

            },

            makeLinks(fn) {

                if(this.skuInfo && this.skuInfo.goods_sign){
                    let params = this.$getExtendLinkParams_pdd();
                    params.pid = this.$common_pdd.getPddPid();
                    params.goods_sign_list = this.skuInfo.goods_sign;
                    params.search_id = this.skuInfo.search_id;

                    this.$getExtendLink_pdd(params, response=>{
                        this.$log(response)
                        if(response && response.code === 200){
                            if(response.data && response.data.goods_promotion_url_generate_response
                                && response.data.goods_promotion_url_generate_response.goods_promotion_url_list
                                && response.data.goods_promotion_url_generate_response.goods_promotion_url_list.length > 0){

                                this.pdd_extend_link = response.data.goods_promotion_url_generate_response.goods_promotion_url_list[0].short_url;

                                if(fn){
                                    fn(this.pdd_extend_link)
                                }
                                this.getPddExtendContent(this.pdd_extend_link);

                            }else{
                                Toast.fail({
                                    message: '购买链接生成失败'
                                })
                            }
                        }else{
                            Toast.fail({
                                message: '购买链接生成失败'
                            })
                        }
                    });
                }
            },


            getPddExtendContent(pdd_extend_link) {
                let content = '';
                // 店铺类型，1-个人，2-企业，3-旗舰店，4-专卖店，5-专营店，6-普通店
                let type = '';
                if(this.skuInfo.merchant_type === 3){
                    type = '【旗舰店】';
                }else if(this.skuInfo.merchant_type ===4){
                    type = '【专卖店】';
                }else if(this.skuInfo.merchant_type ===5){
                    type = '【专营店】';
                }
                content += type + this.skuInfo.goods_name + '\n';
                // content += '评论数: ' + this.skuInfo.comments + '  ';
                // content += '好评率: ' + this.skuInfo.goodCommentsShare + '%' + '\n';
                content += '--------------------------' + '\n';

                if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined'){

                    content +=  '多多价: ' + (this.skuInfo.min_group_price / 100) + '元(券' + this.couponData.discount + '元)' + '\n';

                    content += '内购价: ' + (Number(this.skuInfo.min_group_price/100) - Number(this.couponData.discount)).toFixed(2) + '元' + '\n';
                }else{
                    content +=  '多多价: ' + (this.skuInfo.min_group_price / 100) + '元' + '\n';
                }
                content += '抢购: ' + pdd_extend_link + '\n';
                // content += '--------------------------' + '\n';
                // let second_host_url = this.$store.state.username + '.wapg.cn';
                // content += '更多优惠: ' + second_host_url.toLowerCase();
                this.linkContent = content;
            },

            /**
             * 小程序详情页面点击购买，打开京东小程序(hm使用)
             */
            navigateToJd(jd_url){
                this.$common.navigateToMiniProgramPage("/pages/jd/jd?", "jd", jd_url);
            },


            /**
             * 查找优惠券
             */
            findCoupon() {
                if(this.skuInfo && this.skuInfo.has_coupon){
                    this.couponData.discount = this.skuInfo.coupon_discount / 100;
                    this.couponData.coupon_start_time = this.skuInfo.coupon_start_time;
                    this.couponData.coupon_end_time = this.skuInfo.coupon_end_time;
                    this.couponData.coupon_total_count = this.skuInfo.coupon_total_quantity;
                    this.couponData.coupon_remain_count = this.skuInfo.coupon_remain_quantity;
                }
            },

            initCommission(){
                if(this.skuInfo){
                    this.commissionShare = Number(this.skuInfo.promotion_rate) / 10 * this.$common_pdd.commissionRate_pir;

                    this.commission = 0;
                    if(this.skuInfo.min_group_price){
                        this.commission = (Number(this.skuInfo.min_group_price / 100) - Number(this.skuInfo.coupon_discount / 100)) * this.commissionShare / 100;
                    }else{
                        this.commission = Number(this.skuInfo.min_group_price / 100) * this.commissionShare / 100;
                    }
                    this.commissionShare = this.commissionShare.toFixed(2)
                    this.commission = this.commission.toFixed(2);
                }
            },


            onCopySuccess(){
                Toast.success({
                    message:"文案复制成功"
                })
            },

            onError(){
                Toast.fail({
                    message:"文案复制失败，请尝试手动复制文案"
                })
            },


            getRobotList(){
                this.$getRobotList(list=>{
                    this.robotList = list;
                });
                // let params = {
                //     // channel_name: this.test_channel_name,
                //     channel_name: this.channel_name,
                // };
                //
                // this.$getRobotByChannelname(params, response=>{
                //     if(response && response.code == 200){
                //         this.robotList = response.data.list;
                //     }
                // })
            },

            /**
             * 更新角标（来自Wp_join_robot_button_model）
             */
            updataBadegSync(addOne){
                this.$emit("updataBadegSync", addOne);
            },

            /**
             * 获取全部数据（来自Wp_join_robot_button_model）
             */
            getAllRobatSkuData(data){
                this.$emit("getAllRobatSkuData", data);
            },


            getPushStatus(push_status){
                this.is_pushed = push_status;
            },


            shareImg(){

                if(this.img_list && this.img_list.length > 0){
                    ImagePreview({
                        images: this.getImages(this.img_list),
                        startPosition: this.select_img_index,
                    });
                }else{
                    this.$toast.fail({
                        message: "无图片数据"
                    })
                }
            },
            getImages(_images){

                let imgs = [];
                for(let i = 0; i < _images.length; i++){
                    imgs.push(_images[i].img)
                }
                return imgs;
            },



        }
    }
</script>

<style scoped>
    .sku_title {
        /*height: 45px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .bottom_button{
        padding-top: 1px;
        /*padding-bottom: 50px;*/
        position: fixed;
        bottom: 0px;
        width: 100%;
        background-color: white;
        box-shadow: 1px -1px 3px #888888;
    }


</style>